$(document).ready(function () {
    $(document).on("click", ".js__main_page_brands_toggler", function (e) {
        e.stopPropagation();
        e.preventDefault();
        let group = $(this).attr("data-group");
        $(".js__main_page_brands_toggler").removeClass("active");
        $(this).addClass("active");
        $(".js__brands_page").removeClass("active");
        $('.js__brands_page[data-group="' + group + '"]').addClass("active");
    });
    $(document).on("mouseover", ".js__good_tile_item_toggler", function (e) {
        e.stopPropagation();
        e.preventDefault();
        let id = $(this).attr("data-id");
        $(this)
            .closest(".js__good_tile")
            .find(".js__good_tile_item_toggler")
            .removeClass("active");
        $(this)
            .closest(".js__good_tile")
            .find(".js__good_tile_item")
            .removeClass("active");
        $(this).addClass("active");
        $('.js__good_tile_item[data-id="' + id + '"]').addClass("active");
        $('.good-btn_js[data-id="' + id + '"]').addClass("active");
    });
    // $('.good-tile-img-1').mouseenter(function(){
    //     $('.good-tile-img-2').addClass('active-hover')
    //     $('.good-tile-img-2').mouseleave(function(){
    //         $('.good-tile-img-2').removeClass('active-hover')
    //     })
    // })
    $('.js_select').selectric({
        disableOnMobile: false,
        nativeOnMobile: false
    });
});

window.addEventListener('scroll', () => {
    let mobilePrice = document.querySelectorAll('.mobile-price-fixed')
    let scrollItem = document.querySelector('.footer')
    let windowCenter = window.innerHeight / 2 + window.scrollY
    let scrollRemove = document.querySelector('.footer')
    for (let i = 0; i < mobilePrice.length; i++) {
        let scrollRemoveOffset = scrollRemove.offsetTop / 1.2
        let scrollOffset = scrollItem.offsetTop / 1.2
        if (window.innerWidth < 1024) {
            if (window.scrollY >= scrollOffset) {
                mobilePrice[i].classList.remove('active')
            } else if (window.scrollY > scrollRemoveOffset) {
                mobilePrice[i].classList.add('active')
            }
            else {
                mobilePrice[i].classList.add('active')
            }
        }
    }
})
let iframeBtn = document.querySelectorAll('.js_modal_btn')
let iframe = document.querySelector('.iframe')
let modalIframe = document.querySelector('.modal-iframe')
let closeBtnIframe = document.querySelector('.close-modal-iframe')
let modalContentIframe = document.querySelector('.my-modal-dialog-iframe')
for (let i = 0; i < iframeBtn.length; i++) {
    let dataId = iframeBtn[i].getAttribute('data-video')
    iframeBtn[i].addEventListener('click', function (e) {
        let url = 'https://www.youtube.com/embed/' + dataId + '?autoplay=1'
        iframe.src = url
        modalIframe.classList.add('open')
        document.body.classList.add('lock-modal')
    })
    closeBtnIframe.addEventListener('click', function (e) {
        if (closeBtnIframe) {
            modalIframe.classList.remove('open')
            document.body.classList.remove('lock-modal')
            iframe.src = ''
        }
    })
    modalIframe.addEventListener('click', function (e) {
        if (modalIframe == e.target && modalContentIframe !== e.target) {
            modalIframe.classList.remove('open')
            document.body.classList.remove('lock-modal')
            iframe.src = ''
        }
    })
}


function getHeightTitleGoodBlockTiles() {
    let row_length = 2;
    if (window.innerWidth >= 1366) {
        row_length = 3
    }

    $('.goods-list-block .goods-block').each(function () {
        let rows = {};
        let counter = 0;

        $(this).find('.js__good_tile_item.active .goods-name-top').each(function (i) {
            if (rows[counter]) {
                rows[counter] = [...rows[counter], $(this).height()];
            } else {
                rows[counter] = [$(this).height()];
            }

            if ((i + 1) % row_length === 0) {
                counter++;
            }
        })

        $(this).find('.js__good_tile_item.active .goods-name-top').each(function (i) {
            const row_number = Math.floor(i / row_length);
            const row = rows[row_number].sort().reverse();

            $(this).css('min-height', `${row[0]}px`)
        })
    })
}

function getHeightTitleGoodBlock() {
    $('.goods-block.slick-initialized').each(function (i) {
        let minHeight = 0;

        $(this).find('.goods-name-top').each(function () {
            if (minHeight < $(this).height()) {
                minHeight = $(this).height()
            }
        })

        $(this).find('.goods-name-top').each(function (iter) {
            $(this).css('min-height', `${minHeight}px`)
        })
    })
}

function hoverGoodBlock() {
    $(".js__good_tile").hover(
        function () {
            $(this).find('.d-column').addClass("hover");
            $(this).find('.goods-item-hover-attributes').css('max-height', '200px');
        }, function () {
            $(this).find('.d-column').removeClass("hover");
            $(this).find('.goods-item-hover-attributes').css('max-height', '0px');
        }
    );
}

$(window).resize(function () {
    $('.goods-name-top').css('min-height', `0px`)

    getHeightTitleGoodBlockTiles();
    getHeightTitleGoodBlock();
});

$(window).bind("load", function () {
    getHeightTitleGoodBlockTiles();
    getHeightTitleGoodBlock();
});

$(document).ready(function () {
    hoverGoodBlock()
});